export default {
    form: (sector) => {
        return {
            name: "Modifiko Sektorin",
            submit: {
                label: "Modifiko",
                action: "submitSector",
            },
            fields: [
                [
                    {
                        value: sector.name,
                        name: "name",
                        label: "Emri",
                        type: "text-field",
                        style: "flex-grow: 0.6",
                        required: true,
                        required_text: "Kjo fushe eshte e detyrueshme",
                    },
                ],
            ],
        };
    },
};
